import {
  Box,
  Button,
  Modal,
  Stack,
  TextField,
  Typography,
  useTheme,
  Switch,
  FormControlLabel,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetAllCommentsQuery,
  usePutCommentsMutation,
} from "../../../../../Store/Slices/CommentsSlice/CommentsApi";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

export default function AddCommentModal({ open, setOpen, prCode, varCode }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [putComment, { isLoading, isSuccess }] = usePutCommentsMutation();

  const { first_name } = useSelector((state) => state.userSlice.user);
  const [showName, setShowName] = useState(true); // New state for switch

  const formik = useFormik({
    initialValues: {
      content: "",
    },
    // Handle Submit
    onSubmit: async (values) => {
      try {
        const res = await putComment({
          prCode,
          varCode,
          username: first_name,
          content: values?.content,
          show_name: showName, // Use switch state here
        });

        if(res?.error) return toast.error("مشکلی در ثبت نظر پیش آمد")
        toast.success("نظر شما با موفقیت ثبت شد");
        formik.setValues({
          content: "",
        });
        setOpen(false);
        // Refresh comments
      } catch (err) {
        console.error("Comment submission failed:", err);
        toast.error("!مشکلی پیش آمد");
      }
    },
  });

  return (
    <Modal
      onClose={() => setOpen(false)}
      open={open}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack
        component={"form"}
        onSubmit={formik.handleSubmit}
        sx={{
          bgcolor: theme.palette.background.default,
          borderRadius: "10px",
          padding: "2rem 3rem",
          width: { xs: "300px", md: "500px" },
          height: "300px", // increased height for switch
          justifyContent: "center",
          border: `2px solid ${theme.palette.primary.main}`,
        }}
      >
        <Stack>
          <Typography
            sx={{
              color: theme.palette.primary.main,
              textAlign: "right",
              fontWeight: "bold",
              mb: "24px",
              fontSize: "1.2rem",
            }}
          >
            {first_name || " کاربر مهمان"}
          </Typography>
          <TextField
            hiddenLabel
            id="content"
            placeholder="نظر"
            value={formik.values.content}
            variant="outlined"
            size="small"
            name="content"
            multiline
            fullWidth
            sx={{
              color: theme.palette.secondary.main,
              "& .MuiInputBase-root": {
                direction: "rtl",
                textAlign: "right",
                color: theme.palette.text.main,
                "& fieldset": {
                  borderColor: theme.palette.primary.main,
                },
                "&:hover fieldset": {
                  borderColor: theme.palette.primary.main,
                },
                "&.Mui-focused fieldset": {
                  borderColor: theme.palette.primary.main,
                  borderWidth: "2px !important",
                },
              },
              "& .MuiInputBase-input": {
                color: theme.palette.text.main,
              },
            }}
            onChange={formik.handleChange}
          />
          {/* Switch to toggle show_name */}
          <FormControlLabel
            sx={{ mt: 2, width: "100%" }}
            control={
              <Switch
                checked={showName}
                onChange={() => setShowName((prev) => !prev)}
                color="primary"
              />
            }
            label="نمایش نام من"
            labelPlacement="start"
          />
        </Stack>
        <Stack direction={"row"} gap={"24px"}>
          <Button
            size="small"
            type="submit"
            disabled={!formik.values.content || isLoading}
            variant="contained"
            sx={{
              width: "50%",
              bgcolor: theme.palette.primary.main,
              fontSize: "1.1rem",
              color: "white",
              fontWeight: "bold",
              mx: "auto",
              mt: "20px",
            }}
          >
            ثبت
          </Button>
          <Button
            size="small"
            type="button"
            onClick={() => setOpen(false)}
            variant="outlined"
            sx={{
              width: "50%",
              fontSize: "1rem",
              color: theme.palette.primary.main,
              mx: "auto",
              mt: "20px",
            }}
          >
            صرف نظر
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}
